import { Injectable } from '@angular/core';

import { ApiBaseService } from "../../common/providers/api-base-service";
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Organization } from "../../common/models/organization";
import { Feedback } from "../../common/models/feedback";
import { CurrentUser } from "../../common/providers/current-user";

@Injectable({providedIn: 'root'})
export class QuestionProvider {
    constructor(
        private api: ApiBaseService,
        private currentUser: CurrentUser,
    ) {}

    /**
     * Find all Question for a Feedback
     */
    public findAll(organization: Organization, feedback: Feedback): Observable<FeedbackQuestionSurvey[]> {
        return this.api.call('get',`organizations/${organization.code}/feedback/${feedback.type}`, {}, this.currentUser.getAccessToken())
          .pipe(map((data) => data.map((q: any) => new FeedbackQuestionSurvey(q.id, q.type, q.title, q.help, q.sortOrder))));
    }
}

export class FeedbackQuestionSurvey {
    public id;
    public type;
    public title;
    public help;
    public sortOrder;

    constructor(id: any, type: any, title: any, help: any, sortOrder: any) {
        this.id = id;
        this.type = type;
        this.title = title;
        this.help = help;
        this.sortOrder = sortOrder;
    }
}
